export default "__VITE_ASSET__600fc2ae__"